import React from 'react';
import {
  ClickAwayListener, IconButton, Tooltip,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: '#404852',
    fontSize: 12,
    fontWeight: '600',
    fontFamily: 'Nunito Sans, sans-serif',
    maxWidth: 200,
    lineHeight: 1.8,
    boxShadow: 'none',
    border: '1px solid #e5e5e5',
    padding: '8px 12px',
    margin: '2px 8px 0 0 !important',
  },
}));

export default function Dev({
  open, icon, onClose, onClick, message = '',
}) {
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };
  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div style={{ display: 'inline-block' }}>
        <LightTooltip
          PopperProps={{
            disablePortal: true,
          }}
          onClose={onClose}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={message}
        >
          <IconButton onClick={onClick} sx={{ p: 0 }}>
            {icon}
          </IconButton>
        </LightTooltip>
      </div>
    </ClickAwayListener>
  );
}
